import { ADD_TO_CART, REMOVE_FROM_CART, UPDATE_FOOD_QTY_IN_CART } from "../constants"


export const addToCart = payload => {
    return {
        type: ADD_TO_CART,
        payload: payload
    }
}

export const removeFromCart = payload => {
    return {
        type: REMOVE_FROM_CART,
        payload: payload
    }
}


export const updateFoodQuantityCart = payload => {
    return {
        type: UPDATE_FOOD_QTY_IN_CART,
        payload: payload
    }
}